var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent_div" },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          [
            _c("dd-banner", {
              ref: "ddBannerListRef",
              attrs: {
                swipeList: _vm.cmpbunnerList,
                swiperOptions: _vm.categoryOptions,
                horizontalMode: false
              }
            })
          ],
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "main_content" },
            [
              _c("dd-menu", { ref: "menuRef" }),
              _vm._v(" "),
              _c("dd-content", { ref: "mainContent" })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c("dd-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-787e48a9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-787e48a9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/pages/DcTop.vue
// module id = null
// module chunks = 